import PropTypes from 'prop-types';
import React, {Component} from 'react';
import { connect } from '~/redux/connect';
import ViewWrapper from '~/components/CenterWrapper/CenterWrapper';
//import style from './style.css';

export default class EmptyView extends Component {
    static propTypes = {};

    render() {
        return (
            <ViewWrapper>EmptyView</ViewWrapper>
        );
    }
}